const storeAsync = (key, data) => new Promise(resolve => {
    localStorage.setItem(key, JSON.stringify(data));
    resolve();
});
const retrieveAsync = (key, defaultValue) => new Promise(resolve => {
    const dataAsString = localStorage.getItem(key);
    if (!dataAsString) {
        return resolve(defaultValue === undefined ? null : defaultValue);
    }
    resolve(JSON.parse(dataAsString));
});
const removeAsync = (key) => new Promise(resolve => {
    localStorage.removeItem(key);
    resolve();
});
const LocalStorage = {
    storeAsync,
    retrieveAsync,
    removeAsync
};
export default LocalStorage;
